import React from "react";
import user_types from "./../../../Onboarding/hv-form/userTypes.json";
import { isMobile } from "react-device-detect";

const UserType = ({ onChange, user_type, defaultChecked, disabled }) => (
  <label htmlFor={`${user_type.name}_type`} className="user-type mr-md-3 mb-3">
    <input
      type="radio"
      id={`${user_type.name}_type`}
      value={user_type.name}
      className="d-none"
      defaultChecked={defaultChecked}
      disabled={disabled}
      name="user_type"
      onChange={onChange}
    />
    <div className="d-flex align-items-center">
      <div className="appearance text-center mr-2"></div>
      <p className="text text-capitalize font-weight-normal mb-0">{user_type.title}</p>
    </div>
  </label>
);

export default ({ onUserTypeChanged, user, disabled }) => (
  <div className="form-row">
    <div className="col-100 col-lg-25 d-flex align-items-center" style={isMobile ? { marginBottom: 20 } : {}}>
      <label className="m-0">User Type</label>
    </div>
    <div className="col-100 col-lg-75">
      {user_types.map((user_type) => (
        <UserType onChange={onUserTypeChanged} user_type={user_type} defaultChecked={user.user_type === user_type.name} disabled={disabled} />
      ))}
    </div>
  </div>
);
